<template>
	<div v-loading="loading">
		<div class="ml20 mt20 f18 blue tem-header">
			<div class="cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
			<div class=" flex">
				<el-form>
					<el-form-item label="切换数据" label-width="80px">
						<el-select size="small" @change="changeData" v-model="linkUrl">
							<el-option v-for="(item, index) in portList" :key="index" :value="Number(item.code)" :label="item.name">{{ item.name }}</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="flex">
			<div class="search-form ml20 flex">
				<div class="block flex ml20 mt20">
					<el-form class="time-form">
						<el-form-item label="开始时间" label-width="80px">
							<el-date-picker v-model="value1[0]" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择开始时间"> </el-date-picker>
						</el-form-item>
						<el-form-item label="结束时间" label-width="80px">
							<el-date-picker v-model="value1[1]" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间"> </el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div class="ml10 mt20">
					<el-button type="primary" @click="searchSubmit" size="small">查询</el-button>
				</div>
			</div>
		</div>
		<div id="printm" @dblclick="changeEdit">
			<div class="f-right border-b mt10">
				<div class="flex1">联网单位信息</div>
			</div>
			<table class="table table-bordered mt20" id="basicTable">
				<tbody>
					<tr>
						<td style="text-align: center; font-weight: 600">单位名称</td>
						<td style="text-align: center">{{ form.c_name }}</td>
						<td style="text-align: center; font-weight: 600">单位地址</td>
						<td style="text-align: center">{{ form.c_address }}</td>
					</tr>
					<tr>
						<td style="text-align: center; font-weight: 600">责任人</td>
						<td style="text-align: center">
							{{ form.c_responsible }}
						</td>
						<td style="text-align: center; font-weight: 600">联系电话</td>
						<td style="text-align: center">{{ form.c_phone }}</td>
					</tr>
				</tbody>
			</table>
			<div class="f-right border-b mt10">
				<div class="flex1">维保单位</div>
			</div>
			<table class="table table-bordered" id="xfWeibaodanweiDataGrid">
				<tbody>
					<tr style="font-weight: 600">
						<td>&nbsp;</td>
						<td>维保单位</td>
						<td>联系人</td>
						<td>联系电话</td>
						<td>开始时间</td>
					</tr>
					<tr>
						<td>-</td>
						<td>{{ form.cd_unit_name || "-" }}</td>
						<td>{{ form.cd_user || "-" }}</td>
						<td>{{ form.cd_phone || "-" }}</td>
						<td>{{ form.create_time || "-" }}</td>
					</tr>
				</tbody>
			</table>
			<div class="f-right border-b mt10">
				<div class="flex1">数据统计(单位：次) 注:不重复节点的统计</div>
			</div>

			<table class="table table-bordered" id="jqTable">
				<tbody>
					<tr>
						<td colspan="2" style="text-align: center; font-weight: 600">
							统计时间
						</td>
						<td colspan="10" style="text-align: center">{{ params.starttime }} 至 {{ params.endtime }}</td>
					</tr>
					<tr>
						<td style="text-align: center; font-weight: 600">火警/火警测试</td>
						<td style="text-align: center ;">{{ form.hjsum }}</td>
						<td style="text-align: center">{{ form.hjceshisum }}</td>
						<td style="text-align: center; font-weight: 600">启动/启动测试</td>
						<td style="text-align: center">{{ form.qdsum }}</td>
						<td style="text-align: center">{{ form.qdceshisum }}</td>
						<td style="text-align: center; font-weight: 600">监管/监管测试</td>
						<td style="text-align: center">{{ form.jgsum }}</td>
						<td style="text-align: center">{{ form.jgceshisum }}</td>
						<td style="text-align: center; font-weight: 600">复位/复位测试</td>
						<td style="text-align: center">{{ form.fwsum }}</td>
						<td style="text-align: center">{{ form.fwceshisum }}</td>
					</tr>
					<tr>
						<td style="text-align: center; font-weight: 600">故障/故障测试</td>
						<td style="text-align: center">{{ form.gzsum }}</td>
						<td style="text-align: center">{{ form.gzceshisum }}</td>
						<td style="text-align: center; font-weight: 600">反馈/反馈测试</td>
						<td style="text-align: center">{{ form.fksum }}</td>
						<td style="text-align: center">{{ form.fkceshisum }}</td>
						<td style="text-align: center; font-weight: 600">屏蔽/屏蔽测试</td>
						<td style="text-align: center">{{ form.pbsum }}</td>
						<td style="text-align: center">{{ form.pbceshisum }}</td>
						<td style="text-align: center; font-weight: 600">手动火警</td>
						<td colspan="2" style="text-align: center">{{ form.sdhj }}</td>
					</tr>
					<tr>
						<td style="text-align: center; font-weight: 600">真火警</td>
						<td colspan="2" style="text-align: center">{{ form.zhj }}</td>
						<td style="text-align: center; font-weight: 600">误报率</td>
						<td colspan="2" style="text-align: center">1.00</td>
						<td style="text-align: center; font-weight: 600">测试</td>
						<td colspan="5" style="text-align: center">{{ form.ceshi }}</td>
					</tr>
					<tr>
						<td style="text-align: center; font-weight: 600">查岗次数</td>
						<td colspan="2" style="text-align: center">{{ form.cgcs }}</td>
						<td style="text-align: center; font-weight: 600">在岗次数</td>
						<td colspan="2" style="text-align: center">{{ form.zgcs }}</td>
						<td style="text-align: center; font-weight: 600">漏岗次数</td>
						<td colspan="5" style="text-align: center">{{ form.lgcs }}</td>
					</tr>
				</tbody>
			</table>

			<div class="flex-column center mt20 chart">
				<div id="tab1" class="center printhide"></div>
				<div class="printshow mt20"><img :src="imgUrl" alt="" /></div>
				<!-- <div id="tab2" class="center"></div> -->
			</div>
			<div class="center printhide" style="margin-bottom: 20px">
				<el-button type="primary" @click="more">查看详细数据</el-button>
				<el-button type="primary" @click="printFun" v-print="'#printm'">打印</el-button>
			</div>
			<div class="search-form ml10 mt20 printdetail" v-if="det == 1" v-loading="dtloading">
				<div class="flex ml20">
					<h3>报警统计</h3>
					<!-- <div class="printhide" style="margin-top: 2px">
            <el-dropdown>
              <span class="ml20">
                筛选类型
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu
                slot="dropdown"
                class="tx-center"
                style="height: 300px; overflow: auto"
              >
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
                <el-checkbox-group v-model="checkboxGroup1" @change="hand">
                  <div class="mt10" v-for="(item, key) in $map.bjStatus">
                    <el-checkbox :label="item" :key="item">{{
                      item
                    }}</el-checkbox>
                  </div>
                  c
                </el-checkbox-group>
             
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
					<div class="ml10 printhide flex">
						<el-button size="mini" type="primary" class="ml10" @click="handle">查询</el-button>
					</div>
				</div>
				<div class="flex center" style="width: 100%">
					<div class="common-page center  detaldata">
						<table class="table table-bordered mt20" style="width:97%" id="detailtable">
							<thead>
								<tr>
									<th style="width:50px">序号</th>
									<th style="width:60px">类型</th>
									<th style="width:200px">首次报警时间</th>
									<th style="width:200px">报警地点</th>
									<th style="width:200px">报警节点</th>
									<th style="width:50px">次数</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in alarmList" :key="index">
									<td>{{ index + 1 }}</td>
									<td>{{ item.evenClass }}</td>
									<td>{{ item.nowtime }}</td>
									<td>{{ item.msgDescribe | changecype }}</td>
									<td>{{ item.detailAddr }}</td>
									<td>{{ item.count }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<h3 class="ml10" v-if="testList.length">测试统计</h3>
				<div class="common-page common-list detaldata" v-if="testList.length">
					<table class="table table-bordered mt20" id="detailtable">
						<thead>
							<tr>
								<th>序号</th>
								<th>报警类型</th>
								<th>首次报警时间</th>
								<th>报警地点</th>
								<th>报警节点</th>
								<th>次数</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in testList" :key="index">
								<td>{{ index + 1 }}</td>
								<td>{{ item.evenClass }}</td>
								<td>{{ item.nowtime }}</td>
								<td>{{ item.msgDescribe }}</td>
								<td>{{ item.detailAddr }}</td>
								<td>{{ item.count }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import echarts from "echarts";
	import { getTime } from "../../api/common.js";

	export default {
		components: {},
		data() {
			return {
				editable: false,
				linkUrl: Number(this.$route.query.type) || 3,
				portList: [],
				params: {
					starttime: "",
					endtime: "",
					starttimesql: "",
					endtimesql: "",
					evenClass: "",
					c_company_num: this.$route.query.c_num || this.$route.query.id || "",
				},
				imgUrl: "",
				trendEcharts: "", //echart 名称
				checkboxGroup1: [],
				changeTime: false,
				det: 0,
				dtloading: false,
				nowTime: "",
				// bdstatus:1,
				bdIndex: null,
				id: this.$route.query.id || "",
				loading: false,
				searchForm: this.$getForm("reportDtSearch"),
				edit: false,
				form: {
					wbdw: "---",
					lwdw: "---",
					lxr: "---",
					lxdh: "---",
					startsj: "---",
				},
				formRules: {},
				alarmList: [],
				testList: [],
				value1: [new Date(), null],
				count: 0,
				checkAll: false,
				c_num: this.$route.query.id,
			};
		},
		created() {
			this.$get(`/trxf/main/xf/companyInfo/getCPort/${this.c_num || this.$route.query.id}`).then((res) => {
				this.portList = res.data;
			});
			this.getTime();
			// this.id ? this.getList(): ''
		},
		mounted() {},
		updated() {},
		filters: {
			changecype(val) {
				if (val) {
					return val.replace(/�/g, "");
				}
			},
		},

		methods: {
			changeData() {
				var query = {};
				switch (this.linkUrl) {
					case 1:
						query = { c_num: this.c_num, name: this.$route.query.name, type: 1 };
						break;
					case 2:
						query = { c_num: this.c_num, name: this.$route.query.name, type: 2 };
						break;
					case 5:
						query = { c_num: this.c_num, name: this.$route.query.name, type: 5 };
						break;
					case 8:
						query = { c_num: this.c_num, name: this.$route.query.name, type: 8 };
						this.$local.save("company", {
							c_company_num: this.c_num,
							c_name: this.$route.query.name || "",
						});
						break;
					default:
						query = { id: this.c_num, name: this.$route.query.name, type: this.linkUrl };
				}
				var obj = {
					1: "/score/detail",
					2: "/score/detail",
					3: "/report/report-detail",
					4: "/report/report-detail",
					5: "/score/detail",
					7: "/report/electronic-detail",
					8: "/safe/safe-statistics",
				};

				this.$router.replace({ path: obj[this.linkUrl], query }).then((res) => {
					setTimeout(() => {
						var url = this.linkUrl;
						// this.reload();
						this.linkUrl = url;
					}, 100);
				});
			},
			//双击编辑  仅管理员可以使用
			printFun() {
				var echartsimg = this.trendEcharts.getDataURL(); //图片转码,获得的是base
				this.imgUrl = echartsimg;
			},
			changeEdit() {
				if (this.$store.state.user.company.cCompanyNum === "aaa") this.editable = !this.editable;
			},
			handleCheckAllChange(val) {
				this.checkboxGroup1 = val ? Object.values(this.$map.bjStatus) : [];
			},
			hand(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === Object.values(this.$map.bjStatus).length;
			},

			change() {
				document.body.style.zoom = "200%";
			},
			//开始打印
			doPrint(divText) {
				let subOutputRankPrint = document.getElementById(divText);
				let newContent = subOutputRankPrint.innerHTML;
				let oldContent = document.body.innerHTML;
				document.body.innerHTML = newContent;
				window.print();
				window.location.reload();
				document.body.innerHTML = oldContent;
				return false;
			},
			// 查询提交
			searchSubmit() {
				this.params.starttime = this.value1[0];
				this.params.endtime = this.value1[1];
				//  console.log(this.params)
				this.getList();
				if (this.det) {
					this.getMore();
				}
			},
			handle() {
				var evenclass = this.checkboxGroup1.join(",");
				if (evenclass) {
					this.params.evenClass = evenclass;
				} else {
					this.params.evenClass = "";
				}
				this.getMore();
			},
			getTime() {
				this.loading = true;
				// getTime().then((data) => {
				// let time = data.sysTime2.replace(/-/g, "/");
				let time = new Date(+new Date() + 8 * 3600 * 1000)
					.toJSON()
					.substr(0, 19)
					.replace("T", " ")
					.replace(/-/g, "/");

				let timeLine = new Date(time).getTime();
				this.params.starttime = new Date(timeLine).Format("yy-MM-01 00:00:00");
				this.params.endtime = new Date(timeLine).Format("yy-MM-dd hh:mm:ss");
				this.value1.splice(0, 1, this.params.starttime);
				this.value1.splice(1, 1, this.params.endtime);
				this.getList();
				// });a
			},
			getList() {
				this.loading = true;
				this.$get(`/trxf/main/xf/danwei/xfdanweixinxi/detailbase/${this.id}`).then((res) => {
					// console.log(res);
					var {
						from: {
							base: { c_name, c_address, c_responsible, c_phone },
						},
					} = res;
					this.form = { ...this.form, c_name, c_address, c_responsible, c_phone };
					this.$post("/monitor/reportsci2", this.params).then((RES) => {
						var fom = {};
						for (var i in RES.result) {
							fom[i] = RES.result[i];
						}
						this.form = { ...this.form, ...fom };
						this.chartData();
						this.loading = false;
					});
				});
			},
			chartData() {
				var data = [
					{ value: this.form.hjsum, name: "火警" },
					{ value: this.form.gzsum, name: "故障" },
					{ value: this.form.fwsum, name: "复位" },
					{ value: this.form.jgsum, name: "监管" },
					{ value: this.form.pbsum, name: "屏蔽" },
					{ value: this.form.qdsum, name: "启动" },
					{ value: this.form.fksum, name: "反馈" },
					{ value: this.form.wbl, name: "误报" },
				];
				var arr = [];
				var arr2 = ["火警", "故障", "复位", "监管", "屏蔽", "启动", "反馈", "误报"];
				data.map((item, index) => {
					if (item.value > 0) {
						arr.push(item);
					}
				});

				var arr3 = ["在岗次数", "漏岗次数"];
				var arr4 = [
					{ value: this.form.lgcs, name: "漏岗次数" },
					{ value: this.form.zgcs, name: "在岗次数" },
				];
				this.makeChart(arr, arr2, "tab1", "报警数量");
				// this.makeChart(arr4, arr3, "tab2", "查岗次数");
			},
			makeChart(arr, arr2, id, title) {
				if (arr.length == 0) {
					arr.push({ value: 0, name: "暂无数据" });
				}
				let option = {
					title: {
						text: title,
						left: "center",
						top: "0px",
					},
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b} : {c} ({d}%)",
					},
					legend: {
						orient: "vertical",
						top: "0px",
						right: "0px",
						left: "10px",
						data: arr2,
					},
					series: [
						{
							name: "",
							title: "访问来源",
							show: true,
							type: "pie",
							radius: "60%",
							center: ["50%", "50%"],
							data: arr,
							itemStyle: {
								normal: {
									color: function(params) {
										var colorList = ["#C41A16", "#3D62DE", "#2f4554", "#f7a35c", "#61a0a8", "#41a988", "#91c7ae", "#a5a200"];
										return colorList[params.dataIndex];
									},
								},
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: "rgba(0, 0, 0, 0.5)",
								},
							},
						},
					],
				};
				this.trendEcharts = echarts.init(document.getElementById(id));
				// let trendEcharts = echarts.init(document.getElementById(id));
				this.trendEcharts.setOption(option);
			},
			//提交添加建筑function

			handleCurrentChange(page) {
				this.params.page = page;
				this.getList();
			},
			more() {
				this.det = 1;
				console.log(this.c_num);
				// this.dtloading = true;
				this.getMore();
				this.params.c_company_num = this.c_num;
			},
			//修改建筑信息
			getMore() {
				this.dtloading = true;

				// if (!this.params.evenClass) {
				//   this.params.evenClass = "火警";
				// }
				this.$post("/monitor/reportscidetail", this.params, {
					timeout: 600000,
				}).then((res) => {
					var arr = [];
					if (res.zong) {
						res.zong.map((item) => {
							if (item.length) {
								arr.push(...item);
							}
						});
					}
					//  return

					(this.alarmList = arr || []), (this.testList = res.test);
					this.dtloading = false;
				});
			},
		},
		watch: {},
	};
</script>
<style lang="scss" scoped>
	.table-bordered {
		border: 1px solid #dddddd;
	}

	.table {
		width: 100%;
	}

	#tab1 {
		width: 550px;
		height: 450px;
	}

	.table > tbody > tr > td,
	.table > tbody > tr > th,
	.table > tfoot > tr > td,
	.table > tfoot > tr > th,
	.table > thead > tr > td,
	.table > thead > tr > th {
		padding: 8px;
		vertical-align: top;
		text-align: center;
		border-top: 1px solid #ddd;
	}

	.table-bordered > thead > tr > th,
	.table-bordered > tbody > tr > th,
	.table-bordered > tfoot > tr > th,
	.table-bordered > thead > tr > td,
	.table-bordered > tbody > tr > td,
	.table-bordered > tfoot > tr > td {
		border: 1px solid #dddddd;
	}

	.printdetail {
		width: 100%;
	}

	.printshow {
		display: none;
	}

	// .bord {
	//     border: 1px solid rgb(188, 196, 202) !important;
	//   }
	@media print {
		//   html {
		//     zoom: 200%;
		//   }
		// .card1 {
		//   min-height: 80px;
		// }
		// .card2 {
		//   min-height: 80px;
		// }
		// .card3 {
		//   min-height: 250px;
		// }
		// .card4 {
		//   min-height: 180px;
		// }
		#printm {
		}

		.bord {
			border: 1px solid rgb(188, 196, 202) !important;
		}

		.printdetail {
		}

		.chart {
			margin-top: 20px;
		}

		.printhide {
			visibility: hidden;
			display: none;
		}

		.printshow {
			display: block;
		}

		label {
			font-weight: 900;
		}

		//   @page {
		//   size: 1700px;
		// }
	}
</style>
<style scoped lang="scss" media="print">
	.time-form {
		::v-deep .el-form-item {
			width: 50%;
			display: inline-block;
		}
	}
	.tem-header {
		display: flex;
		justify-content: space-between;
		::v-deep .el-form-item {
			margin-bottom: 0;
		}
	}
</style>
